import { render, staticRenderFns } from "./UserSelectArea.vue?vue&type=template&id=5108eec6&scoped=true&"
import script from "./UserSelectArea.vue?vue&type=script&lang=ts&"
export * from "./UserSelectArea.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelectArea.vue?vue&type=style&index=0&id=5108eec6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108eec6",
  null
  
)

export default component.exports